export default "__VITE_ASSET__B4RRdK8u__"